import { useScrollReveal } from '@/hooks/useScrollReveal';

interface ScrollRevealProps {
  children: React.ReactNode;
  className?: string;
  as?: 'div' | 'section' | 'article' | 'header' | 'footer';
}

export default function ScrollReveal({ children, className = '', as = 'div' }: ScrollRevealProps) {
  const { ref, visible } = useScrollReveal();
  const Tag = as;
  return (
    <Tag ref={ref as React.Ref<HTMLDivElement>} className={`reveal ${visible ? 'visible' : ''} ${className}`}>
      {children}
    </Tag>
  );
}